import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=c27be1e8&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=c27be1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27be1e8",
  null
  
)

export default component.exports